import { render, staticRenderFns } from "./AlertInvitationGetFailure.vue?vue&type=template&id=be0412f2&scoped=true"
import script from "./AlertInvitationGetFailure.vue?vue&type=script&lang=js"
export * from "./AlertInvitationGetFailure.vue?vue&type=script&lang=js"
import style0 from "./AlertInvitationGetFailure.vue?vue&type=style&index=0&id=be0412f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be0412f2",
  null
  
)

export default component.exports